export const sysRouters = [
    {
        path: '/login',
        name:'login',
        component: () => import('@/views/login/loginByPasswowd.vue'),
    },
    {
        path: '/loginByCode',
        name:'loginByCode',
        component: () => import('@/views/login/loginByCode.vue'),
    },
    {
        path: '/loginByPassword',
        name:'loginByPassword',
        component: () => import('@/views/login/loginByPasswowd.vue'),
    },
    {
        path: '/loginByWechat',
        name:'loginByWechat',
        component: () => import('@/views/login/loginByWechat.vue'),
    },
    {
        path: '/loginForLive',
        name:'loginForLive',
        component: () => import('@/views/login/loginForLive.vue'),
    },
    {
        path: '/register',
        name:'register',
        component: () => import('@/views/register/index'),
    },
    {
        path: '/resetPassword',
        name:'resetPassword',
        component: () => import('@/views/resetPassword/index'),
    },
]
